module.exports = __webpack_public_path__ + "img/new17.25b59514.jpg";